import React from 'react';

export const ValidationHeader = ({ stepResolution, icon, headingText, subHeadingText }) => (
    <div className="validation-response__heading validation-response__space" data-result={stepResolution}>
        <img src={icon} alt="icon" />
        <div className="validation-response__heading__text">
            <h3>{headingText}</h3>
            <p>{subHeadingText}</p>
        </div>
    </div>
);
